//import Libraries
import React, { Component } from 'react';
import PropTypes from 'prop-types';

//import Components
import {FormGroup, Button, Col, Label, Input, InputGroup, DropdownMenu, DropdownItem, InputGroupButtonDropdown, DropdownToggle} from 'reactstrap';

//import Styles


class ProductTypeFormGroup extends Component {

    constructor(props){
        super(props);
        this.state = {
            isOpen : false,
            selectingIndex : 0,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.types.length !== this.props.types.length) {
            this.setState({
                selectingIndex : this.props.types.length - 1
            });
            this.props.onShowingTypeChange(this.props.types.length - 1);
        }

        if(this.state.selectingIndex !== prevState.selectingIndex) {
            this.setState({ text: this.props.types[this.state.selectingIndex] })
        }
    }

    toggleDropdown = () => {
        this.setState({
            isOpen : !this.state.isOpen
        })
    }

    handleOnClick=(index)=>{
        this.setState({
            selectingIndex : index
        });
        this.props.onShowingTypeChange(index);
    }

    render() {
        const { types } = this.props;

        const renderItems = types && types.map((item, index) => {
            return (
                <DropdownItem onClick={() => this.handleOnClick(index)}>{item}</DropdownItem>
            )
        })

        const inputValue = (types && types.length > 0) ? types[this.state.selectingIndex] : '';

        return (
            <FormGroup row>
                <Label sm={4} size="sm">{this.props.label}</Label>
                <Col sm={8}>
                    <InputGroup size="sm">
                        <Input
                            name="text"
                            value={inputValue}
                            onChange={this.props.onTextChange}
                            disabled={this.props.disabled}
                        />
                        <InputGroupButtonDropdown addonType="append" isOpen={this.state.isOpen} toggle={this.toggleDropdown} disabled={this.props.disabled}>
                            <DropdownToggle caret disabled={this.props.disabled}>
                            {
                                types ? types[this.state.selectingIndex] : '없음'
                            }
                            </DropdownToggle>
                            <DropdownMenu>
                                {renderItems}
                                <DropdownItem divider></DropdownItem>
                                <DropdownItem onClick={this.props.onAddNewDefault}>추가</DropdownItem>
                            </DropdownMenu>
                        </InputGroupButtonDropdown>
                    </InputGroup>
                    <Button onClick={() => this.props.onRemove(this.state.selectingIndex)} disabled={this.props.disabled}>삭제</Button>
                </Col>
            </FormGroup>
        );
    }
}
export default ProductTypeFormGroup;

ProductTypeFormGroup.defaultProps = {
    disabled : false
}

ProductTypeFormGroup.propTypes = {
    disabled : PropTypes.bool
}


// WEBPACK FOOTER //
// ./src/pages/Admin/ProductManager/Category/Product/Elements/ProductTypeFormGroup.js